/* sc-shopify-bridge.js
 * Patches the SC prototype's asset references for Shopify.
 *
 * In the prototype, local images live at assets/img/foo.jpg.
 * In Shopify, they're served from the theme's CDN at
 * https://cdn.shopify.com/s/files/1/SHOP_ID/.../assets/foo.jpg
 *
 * This script:
 * 1. Sets SC.assetBase from the Liquid-injected data attribute
 * 2. Monkey-patches string concatenation patterns to rewrite
 *    'assets/img/xxx' to the Shopify asset URL
 * 3. Rewrites .html links to Shopify routes
 */
(function() {
  'use strict';

  window.SC = window.SC || {};

  /* The asset base URL is injected by theme.liquid as a data attribute
     on the script tag. This avoids needing Liquid inside the JS file. */
  var scripts = document.getElementsByTagName('script');
  var bridgeScript = null;
  for (var i = 0; i < scripts.length; i++) {
    if (scripts[i].getAttribute('data-sc-asset-base')) {
      bridgeScript = scripts[i];
      break;
    }
  }
  var assetBase = bridgeScript ? bridgeScript.getAttribute('data-sc-asset-base') : '';
  SC.assetBase = assetBase;

  /* Rewrite local asset paths after all SC scripts load.
     We patch the generated HTML by intercepting innerHTML sets
     on mount points. Simpler alternative: just do a global
     find-replace on the rendered HTML after mounting. */
  var originalBoot = null;

  document.addEventListener('DOMContentLoaded', function() {
    /* After page boot, walk all SC mount points and rewrite paths */
    setTimeout(function() { rewriteAssetPaths(); }, 50);
  });

  function rewriteAssetPaths() {
    /* Rewrite local image paths.
       Shopify assets are flat (no subdirectories), so
       assets/img/editorial/foo.jpg → {assetBase}foo.jpg
       assets/img/foo.jpg → {assetBase}foo.jpg */
    document.querySelectorAll('img[src^="assets/"]').forEach(function(img) {
      var src = img.getAttribute('src');
      /* Strip any directory prefix down to the filename */
      var filename = src.split('/').pop();
      img.setAttribute('src', assetBase + filename);
    });

    /* Rewrite .html links to Shopify routes */
    document.querySelectorAll('a[href$=".html"], a[href*=".html#"], a[href*=".html?"]').forEach(function(a) {
      var href = a.getAttribute('href');
      /* index.html → / */
      href = href.replace(/^index\.html/, '/');
      /* gallery.html → /pages/gallery */
      href = href.replace(/^gallery\.html/, '/pages/gallery');
      /* bed-linen.html → /collections/bed-linen */
      href = href.replace(/^bed-linen\.html/, '/collections/bed-linen');
      /* bed-linen-scalloped.html → /collections/bed-linen-scalloped */
      href = href.replace(/^bed-linen-scalloped\.html/, '/collections/bed-linen-scalloped');
      /* portmeirion.html → /collections/portmeirion */
      href = href.replace(/^portmeirion\.html/, '/collections/portmeirion');
      /* portmeirion-bestsellers.html → /collections/portmeirion-bestsellers */
      href = href.replace(/^portmeirion-bestsellers\.html/, '/collections/portmeirion-bestsellers');
      /* john-lewis.html → /pages/john-lewis */
      href = href.replace(/^john-lewis\.html/, '/pages/john-lewis');
      /* sophies-world.html → /pages/sophies-world */
      href = href.replace(/^sophies-world\.html/, '/pages/sophies-world');
      /* in-stock-now.html → /collections/in-stock-now */
      href = href.replace(/^in-stock-now\.html/, '/collections/in-stock-now');
      /* account.html → /account */
      href = href.replace(/^account\.html/, '/account');
      /* trade.html → /pages/trade */
      href = href.replace(/^trade\.html/, '/pages/trade');
      /* cart.html → /cart */
      href = href.replace(/^cart\.html/, '/cart');
      /* fabric-picker.html → /pages/fabric-picker */
      href = href.replace(/^fabric-picker\.html/, '/pages/fabric-picker');
      /* room-quiz.html → /pages/room-quiz */
      href = href.replace(/^room-quiz\.html/, '/pages/room-quiz');
      /* will-it-fit.html → /pages/will-it-fit */
      href = href.replace(/^will-it-fit\.html/, '/pages/will-it-fit');
      /* product-coco-3.html → /products/coco-3-seater (approximate) */
      href = href.replace(/^product-([a-z]+)-(\d.*)\.html/, '/products/$1-$2');
      a.setAttribute('href', href);
    });

    /* Rewrite background images set via style attributes */
    document.querySelectorAll('[style*="assets/img/"]').forEach(function(el) {
      var style = el.getAttribute('style');
      style = style.replace(/assets\/img\//g, assetBase);
      el.setAttribute('style', style);
    });
  }

  /* Expose for re-running after dynamic content loads */
  SC.rewriteAssetPaths = rewriteAssetPaths;

  /* ── Transparent → Solid header transition ──
     On the homepage, the header starts transparent over the hero image
     (white icons/logo). Once the user scrolls past the hero, it
     transitions to the solid paper background with navy icons.
     Only active on pages with data-sc-page="index" (homepage). */

  document.addEventListener('DOMContentLoaded', function() {
    var page = document.body.getAttribute('data-sc-page');
    if (page !== 'index') return;

    var header = document.querySelector('.sc-header');
    if (!header) return;

    /* Add the transparent class initially */
    header.classList.add('sc-header--transparent');

    /* Find the hero section to measure its height */
    var heroEl = document.querySelector('.sc-hero-lifestyle, .sc-hero-section, [class*="sc-hero"]');
    var heroBottom = 0;

    function updateHeroBottom() {
      if (heroEl) {
        var rect = heroEl.getBoundingClientRect();
        heroBottom = rect.bottom + window.scrollY - 60; /* switch 60px before hero ends */
      } else {
        heroBottom = window.innerHeight * 0.5;
      }
    }
    updateHeroBottom();
    window.addEventListener('resize', updateHeroBottom);

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function() {
          if (window.scrollY > heroBottom) {
            header.classList.remove('sc-header--transparent');
          } else {
            header.classList.add('sc-header--transparent');
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  });
})();
